var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _path17, _path18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniSchool03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.746094,
    y: 0.0527344,
    width: 258,
    height: 252,
    fill: "#4A5294"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_502_15585",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.746094,
    y: 0.0527344,
    width: 258,
    height: 252,
    fill: "#D6895E"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_502_15585)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9863 166.977L136.485 125.9L250.377 164.05L161.422 207.191L52.9863 166.977Z",
    fill: "#2F231F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M251.561 163.612L269.855 154.658L269.592 158.042L251.561 167.337L251.561 163.612Z",
    fill: "#BA6649"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M251.55 163.634L247.807 161.492L247.808 165.322L251.55 167.359L251.55 163.634Z",
    fill: "#512A1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M185.842 191.092L326.949 121.885V126.764L185.842 195.731V191.092Z",
    fill: "#BA6649"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.825 191.08L71.959 153.02L72.0348 157.697L185.889 195.757L185.838 191.08H185.825Z",
    fill: "#D29C85"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9355 152.93L213.042 83.7734L326.934 121.923L185.827 191.079L71.9355 152.93Z",
    fill: "#D3896E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M196.51 166.164L82.6434 128.104L74.9453 151.4L188.799 189.461L196.522 166.164H196.51Z",
    fill: "#FFEEE7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M196.509 166.152L82.6426 128.091L145.378 106.299L259.232 144.36L196.509 166.152Z",
    fill: "#F2E1DA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M196.509 166.152L82.6426 128.091L145.378 106.299L259.232 144.36L196.509 166.152Z",
    fill: "url(#paint0_linear_502_15585)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M196.509 166.153L188.836 189.677L259.231 155.446V144.373L196.509 166.165V166.153Z",
    fill: "#C6AEA4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M308.82 113.897L194.953 75.8359L145.377 106.287L259.231 144.348L308.82 113.897Z",
    fill: "#FFEEE7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M308.82 113.897L194.953 75.8359L145.377 106.287L259.231 144.348L308.82 113.897Z",
    fill: "url(#paint1_linear_502_15585)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M144.972 106.413L259.016 144.145L221.713 88.9055L107.645 51.502L144.972 106.413Z",
    fill: "#512A1D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_502_15585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: 115,
    width: 67,
    height: 24
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M113.752 138.03L107.646 118.121L167.31 115.555L173.415 135.451L113.752 138.03Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_502_15585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.22 132.958L117.266 130.733L119.213 129.924C119.883 129.646 120.603 129.494 121.349 129.469C122.436 129.418 123.549 129.621 124.585 130.013C126.304 130.645 126.759 131.403 125.356 132.06L125.167 132.136L123.22 132.945M120.768 127.75C119.314 127.813 117.936 128.079 116.735 128.584L111.527 130.758L129.174 137.357L131.929 136.206L126.178 134.058L128.567 133.059C128.681 133.008 128.807 132.958 128.921 132.907C131.575 131.656 130.817 130.076 127.429 128.812C125.331 128.028 122.967 127.649 120.768 127.737",
    fill: "#C6AEA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.096 130.406C138.628 130.432 138.211 130.495 137.92 130.634L137.819 130.684C137.048 131.051 137.288 131.645 138.388 132.05C139.07 132.315 139.955 132.441 140.739 132.403C141.219 132.378 141.662 132.302 141.99 132.163L142.053 132.138C142.787 131.797 142.559 131.177 141.459 130.76C140.752 130.495 139.854 130.381 139.096 130.419",
    fill: "#C6AEA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.59 126.107L133.636 123.883L135.583 123.074C136.253 122.796 136.973 122.644 137.706 122.619C138.781 122.568 139.906 122.77 140.942 123.162C142.662 123.794 143.117 124.54 141.726 125.21L141.524 125.298L139.577 126.12M137.1 120.912C135.646 120.975 134.268 121.241 133.067 121.746L127.859 123.921L145.518 130.532L148.274 129.381L142.51 127.22L144.899 126.234C145.013 126.183 145.139 126.133 145.24 126.082C147.907 124.818 147.136 123.251 143.761 121.987C141.663 121.203 139.299 120.811 137.087 120.912",
    fill: "#C6AEA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.232 117.904L139.527 119.042L157.186 125.64L159.891 124.515L142.232 117.904Z",
    fill: "#C6AEA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.313 119.7C154.91 119.131 154.506 118.334 155.618 117.816L155.757 117.753C156.212 117.563 156.781 117.45 157.4 117.424C158.412 117.386 159.549 117.551 160.56 117.93L156.326 119.712M156.743 116.021C155.289 116.084 154.013 116.35 152.989 116.78C152.888 116.83 152.799 116.856 152.711 116.919C150.132 118.12 151.093 119.889 155.036 121.356C157.628 122.329 160.346 122.784 162.76 122.67C164.239 122.607 165.617 122.329 166.767 121.849C166.881 121.798 166.982 121.76 167.083 121.71C169.207 120.698 169.194 119.485 167.209 118.448L164.643 119.535C165.136 119.915 165.048 120.382 164.239 120.761L164.138 120.812C163.607 121.027 162.975 121.153 162.292 121.179C161.155 121.229 159.853 121.014 158.601 120.547L165.389 117.715L164.365 117.336C161.622 116.312 158.98 115.92 156.743 116.021Z",
    fill: "#C6AEA4"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9355 133.273L131.46 150.224",
    stroke: "#F7E5DF",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6719 137.105L174.552 168.934",
    stroke: "#F7E5DF",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M141.332 163.258L191.869 180.209",
    stroke: "#F7E5DF",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M182.414 242.053V222.256H190.18C194.678 222.256 197.262 225.031 197.262 228.928C197.262 232.879 194.637 235.6 190.07 235.6H186.516V242.053H182.414ZM186.516 232.291H189.414C191.848 232.291 193.037 230.924 193.023 228.928C193.037 226.959 191.848 225.633 189.414 225.619H186.516V232.291ZM201.227 242.299C199.941 242.299 198.902 241.273 198.93 240.002C198.902 238.744 199.941 237.719 201.227 237.732C202.443 237.719 203.496 238.744 203.496 240.002C203.496 241.273 202.443 242.299 201.227 242.299ZM206.832 242.053V222.256H214.598C219.096 222.256 221.68 225.031 221.68 228.928C221.68 232.879 219.055 235.6 214.488 235.6H210.934V242.053H206.832ZM210.934 232.291H213.832C216.266 232.291 217.455 230.924 217.441 228.928C217.455 226.959 216.266 225.633 213.832 225.619H210.934V232.291ZM228.242 222.256V242.053H224.195V222.256H228.242ZM238.113 242.354C233.561 242.34 230.771 239.4 230.785 234.697C230.771 230.117 233.602 227.014 237.949 227.014C241.846 227.014 244.922 229.475 244.922 234.533V235.682H234.777C234.777 237.924 236.104 239.305 238.195 239.318C239.576 239.305 240.561 238.703 240.957 237.814H244.812C244.238 240.562 241.777 242.34 238.113 242.354ZM234.777 233.139H241.094C241.08 231.334 239.836 230.035 238.031 230.049C236.172 230.035 234.859 231.43 234.777 233.139Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_15585",
    x1: 186.048,
    y1: 114.773,
    x2: 179.076,
    y2: 136.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2CABF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890366,
    stopColor: "#FFEEE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_502_15585",
    x1: 205.041,
    y1: 125.111,
    x2: 217.062,
    y2: 93.6162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2C8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687351,
    stopColor: "#FFEFE8",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniSchool03);
export default __webpack_public_path__ + "static/media/mini_school_03.69782b365448512e8ab63e6d8b383689.svg";
export { ForwardRef as ReactComponent };